import React, { useEffect, useRef, useState } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaFileDownload, FaUpload } from 'react-icons/fa';
import moment from 'moment';
import api from '../../services/api';
import '../../css/financeiro-parcela-pagar.css';

export default function ImportarOrcamento({ match }) {
    const idEvento = match.params.id;
    const empresa = localStorage.getItem("empresa");
    const token = localStorage.getItem('token');
    const [arquivos, setArquivos] = useState([]);
    const [nomeEvento, setNomeEvento] = useState('');
    const [nomeCliente, setNomeCliente] = useState('');
    const [uploading, setUploading] = useState(false);
    const fileRef = useRef(null);
    const history = useHistory();

    const buscarEvento = () => {
        if (!idEvento) {
            return;
        }
        api({
            method: 'get',
            action: '/evento/' + idEvento,
            token
        })
            .then((response) => {
                setNomeEvento(response.data.data.nome);
                if (response.data.data.cliente) {
                    setNomeCliente(response.data.data.cliente.nome);
                }
            })
            .catch(() => {});
    };

    const buscarArquivos = () => {
        if (!idEvento) {
            return;
        }
        api({
            method: "get",
            action: '/eventoArquivo',
            token,
            params: {
                tipo: "orcamento",
                evento: idEvento,
            }
        })
            .then((response) => {
                setArquivos(response.data.data || []);
            })
            .catch(() => {});
    };

    useEffect(() => {
        buscarEvento();
        buscarArquivos();
        // eslint-disable-next-line
    }, []);

    const abrirSeletorArquivo = () => {
        if (uploading) {
            return;
        }
        fileRef.current?.click();
    };

    const enviarArquivo = async (event) => {
        const arquivo = event.target.files?.[0];
        if (!arquivo) {
            return;
        }

        const formData = new FormData();
        formData.append('file', arquivo);
        formData.append('empresa', empresa);
        formData.append('evento', idEvento);

        setUploading(true);
        toast.info('Aguarde, isso pode levar alguns minutos');

        try {
            const response = await fetch(process.env.REACT_APP_API_URL + '/orcamentoImportar', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: formData,
            });
            const payload = await response.json();
            const data = payload?.data ?? payload;

            if (data?.result === "sucesso") {
                toast.success('Importação finalizada');
                history.push("/orcamento?idEvento=" + idEvento);
                return;
            }

            toast.error(data?.message || data?.error || payload?.message || payload?.error || "Erro desconhecido");
        } catch (error) {
            toast.error("Erro ao enviar arquivo");
        } finally {
            setUploading(false);
            event.target.value = "";
        }
    };

    const baixarArquivo = (idArquivoEvento) => {
        if (!idArquivoEvento) {
            return;
        }
        window.open(`${process.env.REACT_APP_API_URL}/eventoArquivo/${idArquivoEvento}`, '_blank');
    };

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <input ref={fileRef} type="file" style={{ display: 'none' }} onChange={enviarArquivo} />

                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Importar Orçamento</h1>
                        <p className="fin-pp__subtitle">
                            {nomeEvento ? `${nomeEvento}${nomeCliente ? ` · ${nomeCliente}` : ''}` : 'Importação de planilha para o evento'}
                        </p>
                    </div>
                    <div className="fin-pp__actions">
                        <button
                            type="button"
                            className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill"
                            onClick={abrirSeletorArquivo}
                            disabled={uploading}
                        >
                            <FaUpload size={14} /> {uploading ? 'Enviando...' : 'Selecionar Arquivo'}
                        </button>
                    </div>
                </div>

                <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                    <div className="fin-pp__cphead">
                        <div>
                            <h2 className="fin-pp__cphead-title">Carga da planilha</h2>
                            <p className="fin-pp__cphead-sub">Envie a planilha de orçamento vinculada ao evento. Após o processamento, o fluxo retorna para a listagem.</p>
                        </div>
                        <span className="fin-pp__pill is-info">{arquivos.length} arquivo(s)</span>
                    </div>
                </div>

                <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                    <div style={{ padding: 16 }}>
                        <div className="fin-pp__cphead">
                            <div>
                                <h2 className="fin-pp__cphead-title">Arquivos importados</h2>
                                <p className="fin-pp__cphead-sub">Histórico de planilhas vinculadas ao evento.</p>
                            </div>
                        </div>
                    </div>
                    <div className="fin-pp__tblwrap">
                        <table className="fin-pp__tbl" style={{ minWidth: 760, tableLayout: 'auto' }}>
                            <thead>
                                <tr>
                                    <th style={{ width: 110 }}>Arquivo</th>
                                    <th style={{ width: 180 }}>Data</th>
                                    <th>Operador</th>
                                </tr>
                            </thead>
                            <tbody>
                                {arquivos.length === 0 ? (
                                    <tr>
                                        <td colSpan={3} className="fin-pp__empty">Nenhum arquivo importado.</td>
                                    </tr>
                                ) : (
                                    arquivos.map((arquivoEvento) => (
                                        <tr key={arquivoEvento.id}>
                                            <td>
                                                {arquivoEvento.arquivo?.id ? (
                                                    <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={() => baixarArquivo(arquivoEvento.id)}>
                                                        <FaFileDownload size={12} /> Baixar
                                                    </button>
                                                ) : (
                                                    <span className="fin-pp__cell-muted">-</span>
                                                )}
                                            </td>
                                            <td>{arquivoEvento.created_at ? moment(arquivoEvento.created_at).format("DD/MM/YYYY HH:mm") : ''}</td>
                                            <td>{arquivoEvento.operador?.nome ?? ''}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </ErpTemplate>
    );
}
